import React, { Component } from 'react';
import CanvasElement, { CanvasElementPropTypes } from '../../../canvas-element';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import SelectedElementWrapperUtil from '../utils';
import { observer } from 'mobx-react';
import { transformOfFlip } from '../../../common';
import ObserverFactory from '@src/slide/application/service/modelObserver/observerFactory';
import { SelectedEleMgrType } from '@src/slide/domain/selection/constant/select-element-type';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { GroupRefreshMenu } from '@src/slide/domain/ui-model/element-modeles/property/menu-property/refresh/group';

@observer
export default class SelectedSmartArtWrapper extends Component {
    static propTypes = {
        element: PropTypes.object.isRequired,
        scale: PropTypes.number.isRequired,
        selectedElementInGroupInMobile: PropTypes.bool,
        onBorderClick: PropTypes.func,
    };

    handleBorderMouseDown = () => {
        this.getSelectionService()?.selectedElements.clear(SelectedEleMgrType.SMART_ART);
    };

    getSelectionService() {
        return AppServiceProvider.getInstance().getAppServices().viewableServiceLayer?.selectionService;
    }

    getRotateElementHandler() {
        return AppServiceProvider.getInstance().getAppServices().editableServiceLayer?.rotateElementHandler;
    }

    componentDidMount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.addLocalChangeObserver(this.updateComponent);
            observer.addChangesetObserver(this.updateComponent);
        }
        const elementModel = this.props.element;
        if (elementModel.isRootSmartArt) {
            // 选中组合元素后需要刷新组合元素item
            GroupRefreshMenu.caculateItemValues(elementModel);
        }
    }

    updateComponent = () => {
        this.forceUpdate();
    };

    componentWillUnmount() {
        const observer = ObserverFactory.createObserver(this.props.element);
        if (observer) {
            observer.removeLocalChangeObserver(this.updateComponent);
            observer.removeChangesetObserver(this.updateComponent);
        }
    }

    render() {
        const elementModel = this.props.element;
        const frameInfo = SelectedElementWrapperUtil.frameInfoForInner(elementModel);
        const frameWithOp = elementModel.getFrame?.().getFrameInfo(true);
        const relativeInfo = SelectedElementWrapperUtil.relativeInfoForInner(elementModel);
        const { isRootSmartArt } = elementModel;
        let rootSmartArtFrame = {};
        if (isRootSmartArt) {
            const rect = elementModel.getFrame?.().getFrameInfo(!!elementModel.operationFrame);
            rootSmartArtFrame = {
                left: rect.left,
                top: rect.top,
                width: rect.width,
                height: rect.height,
            };
        }
        return (
            <CanvasElement
                {...pick(this.props, Object.keys(CanvasElementPropTypes))}
                showSelectBorder={true}
                scale={this.props.scale}
                rect={{
                    left: rootSmartArtFrame.left,
                    top: rootSmartArtFrame.top,
                    width: rootSmartArtFrame.width,
                    height: rootSmartArtFrame.height,
                }}
                editable={true}
                resizeHorizontal={true}
                resizeVertical={true}
                canRotate={false}
                relativeRotate={relativeInfo.relativeRotate}
                relativeFlipH={relativeInfo.relativeFlipH}
                relativeFlipV={relativeInfo.relativeFlipV}
                rotate={frameInfo.rotate}
                {
                    ...SelectedElementWrapperUtil
                        .commonPropsForCanvasElement(elementModel, this.props.scale)
                }
                style={{
                    transform: transformOfFlip(frameWithOp),
                    width: isRootSmartArt ? rootSmartArtFrame.width : frameWithOp.width,
                    height: isRootSmartArt ? rootSmartArtFrame.height : frameWithOp.height,
                    position: 'absolute',
                }}
                onBorderMouseDown={this.handleBorderMouseDown}
                onBorderClick={(e) => {
                    this.props.onBorderClick?.(e);
                }}
                selectedElementInGroupInMobile={this.props.selectedElementInGroupInMobile}
                isMobileRotatingMode={this.getRotateElementHandler()?.isMobileRotatingMode ?? false}
            >
            </CanvasElement>
        );
    }
}
